import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';

export default class FollowRecommendationsFirstRunCongrats extends React.Component {
  static propTypes = {
    user: UserShape
  }

  render() {
    return (
      <div className='row public-profile-confirmation'>
        <div className='offset-sm-2 col-sm-8'>
          <p>
            Done! You are now following people, and people can follow you.
          </p>
        </div>
        <div className='offset-sm-2 col-sm-8 action'>
          <Link to={ `/people/${this.props.user.get('slug')}` } className='btn btn-dark'>See what others see</Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/follow_recommendations_first_run_congrats.jsx